<section class="rongo-observation-heading">
  <h2>{{ observation.location ?? 'Observation' }}</h2>
  <p>
    {{ observation.reportedObservationDate ?? observation.date | date : 'medium'
    }}<a
      [href]="currentHost + '/mapview/observation/' + observation.id"
      target="_blank"
      style="padding-left: 3px; outline: none"
      >Share</a
    >
  </p>
</section>

<section class="rongo-observation-summary">
  <div class="select">
    <p>
      <span class="question-text">Energy Level: </span><span class="answer-text"> {{ energyLevel }}</span>
    </p>
    <p>
      <span class="question-text">Lunar Stage: </span
      ><span class="answer-text"> {{ lunarStageEng }} {{ lunarStageReo }}</span>
    </p>
    <p>
      <span class="question-text">Lunar Month: </span><span class="answer-text"> {{ lunarMonth }}</span>
    </p>
  </div>
</section>

<div [innerHTML]="sanitizedLayoutHtml"></div>
